export default __webpack_public_path__ + "static/media/circle3.28fe6b07.png";